import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ComponentScrollService {

	constructor() { }

	private static initAz = true;
	private static initCategory = true;
	private static initSearchResult = true;
	private static initInternationalCatalog = true;

	public resetAzValues() {
		ComponentScrollService.initAz = true;
	}

	public resetCategoryValues() {
		ComponentScrollService.initCategory = true;
	}

	public resetSearchResultValues() {
		ComponentScrollService.initSearchResult = true;
	}

	public resetInternationalCatalogsValues() {
		ComponentScrollService.initInternationalCatalog = true;
	}

	public setAzValues() {
		ComponentScrollService.initAz = false;
	}

	public setCategoryValues() {
		ComponentScrollService.initCategory = false;
	}

	public setSearchResultValues() {
		ComponentScrollService.initSearchResult = false;
	}

	public setInternationalCatalogsValues() {
		ComponentScrollService.initInternationalCatalog = false;
	}

	public hasInitAzValues() {
		return ComponentScrollService.initAz;
	}

	public hasInitCategoryValues() {
		return ComponentScrollService.initCategory;
	}

	public hasInitSearchResultValues() {
		return ComponentScrollService.initSearchResult;
	}

	public hasInitInternationalCatalogsResultValues() {
		return ComponentScrollService.initInternationalCatalog;
	}
}
